<script lang="ts" setup>
import { computed } from 'vue'
import { useGalleryState } from '@/composables/useGalleryState'
import { userInteractionEvent } from '@/composables/userInteractionEvent'
import { useLanguage, useTranslateSource } from '@/composables/useLanguage'

const { language } = useLanguage()
const { ts } = useTranslateSource()
const textShowThumbs = ts(language.value, 'showThumbnails')
const textClose = ts(language.value, 'close')
const textZoomIn = ts(language.value, 'zoomIn')

const { gallery, activeSlide, showThumbnails } = useGalleryState()
const { INTERACTION_CLICK } = userInteractionEvent()

const emit = defineEmits<{
  (e: 'slideNext'): void
  (e: 'slidePrev'): void
  (e: 'onInteraction', interactionSource: string): void
  (e: 'zoomIn'): void
}>()

const clickThumbnails = () => {
  showThumbnails.value = !showThumbnails.value
}
const clickPrev = () => {
  emit('slidePrev')
  emit('onInteraction', INTERACTION_CLICK)
}
const clickNext = () => {
  emit('slideNext')
  emit('onInteraction', INTERACTION_CLICK)
}
const clickZoomIn = () => {
  emit('zoomIn')
}

const imagesLength = computed(() => {
  return gallery.value.images.length
})
</script>

<template>
  <div class="buttons">
    <i class="icon-left"></i>
    <div v-show="!showThumbnails" class="controls">
      <a class="prev" @click.stop="clickPrev">
        <svg aria-label="Previous" class="svg-icon">
          <use xlink:href="#svg-icon-chevron-left"></use>
        </svg>
      </a>
      <div class="counter">{{ activeSlide + 1 }}&nbsp;/&nbsp;{{ imagesLength }}</div>
      <a class="next" @click.stop="clickNext">
        <svg aria-label="Next" class="svg-icon">
          <use xlink:href="#svg-icon-chevron-right"></use>
        </svg>
      </a>
      <a class="zoom-in" @click.stop="clickZoomIn">
        <svg aria-hidden="true" class="svg-icon" viewBox="0 0 24 24">
          <use xlink:href="#svg-icon-zoom-in"></use>
        </svg>
        <span>{{ textZoomIn }}</span>
      </a>
      <a class="to-thumbnails" @click.stop="clickThumbnails">
        <svg aria-hidden="true" class="svg-icon" viewBox="0 0 16 16">
          <use xlink:href="#svg-icon-thumbnails"></use>
        </svg>
        <span>{{ textShowThumbs }}</span>
      </a>
    </div>
    <a :href="gallery?.closeUrl" class="exit-link">
      <span>{{ textClose }}</span>
      <svg aria-hidden="true" class="svg-icon" viewBox="0 0 24 24">
        <use xlink:href="#svg-icon-cross-solid"></use>
      </svg>
    </a>
  </div>
</template>
